module.exports = __webpack_public_path__ + "img/export.008ef8ae.svg";